import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { createRoot } from 'react-dom/client';
import App from './App';
import './polyfills';

// TODO: move this to a better place.
CapacitorUpdater.notifyAppReady();

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
